import { useEffect } from 'react';
import { EditorContent } from '@tiptap/react';

import { CommentReadSurface } from '../styles';
import { useCommentEditor } from './useCommentEditor';
import { commentContentToText, parseCommentContent } from './content';

interface CommentContentViewProps {
  content: string;
  mentionsEnabled: boolean;
}

const CommentContentView: React.FC<CommentContentViewProps> = ({ content, mentionsEnabled }) => {
  const editor = useCommentEditor({ mentionsEnabled, editable: false });

  useEffect(() => {
    if (editor) {
      editor.commands.setContent(content ? parseCommentContent(content) : '');
    }
  }, [editor, content]);

  if (!mentionsEnabled || !editor) {
    return <>{commentContentToText(content)}</>;
  }

  return (
    <CommentReadSurface>
      <EditorContent editor={editor} />
    </CommentReadSurface>
  );
};

export default CommentContentView;
